import { useUserProfile } from '@/modules/settings/hooks/account/use-user-profile';

import { ApprovalStatus, TimeOffRequest, TimeOffRequestApprover } from '../types/time-off-request';

/**
 * Resolves the current user's own approver row on a time-off request.
 *
 * A request can have several approvers; while the request as a whole is still
 * PENDING, the current user may already have approved or rejected their part and
 * can reverse it. Returns `null` when the current user is not among the approvers
 * (or the profile isn't loaded yet).
 */
export const useCurrentApproverEntry = (request: TimeOffRequest): TimeOffRequestApprover | null => {
  const { userProfile } = useUserProfile();

  if (!userProfile) return null;

  return request.approvers.find(item => item.user.id === userProfile.id) ?? null;
};

/** Convenience wrapper over {@link useCurrentApproverEntry} for callers that only need the decision. */
export const useCurrentApproverDecision = (request: TimeOffRequest): ApprovalStatus | null => {
  const entry = useCurrentApproverEntry(request);
  return entry?.status ?? null;
};
